var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconaPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.051,
    height: 36.992,
    viewBox: "0 0 34.051 36.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1182",
    "data-name": "Raggruppa 1182",
    transform: "translate(-909.775 -668.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_312",
    "data-name": "Tracciato 312",
    d: "M-12963.086-13136.3v-10.869H-12945l6.979,6.979v28.014h-25.065v-7.012",
    transform: "translate(13880.847 13816.998)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_313",
    "data-name": "Tracciato 313",
    d: "M-12948.223-13147v6.627h7.165",
    transform: "translate(13883.927 13817.034)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(909.775 693.381)",
    fill: "#232323",
    fontSize: 14,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaPdf);
export default __webpack_public_path__ + "static/media/icona_PDF.7f7dca5b59efadab0f5688fef4b1bc6f.svg";
export { ForwardRef as ReactComponent };